<template>
  <div class="box9" ref="box9">
  
  </div>
</template>

<script>

export default {

  data() {
    return {
     
    };
  },
  methods: {
    zixun(name) {
      zhuge.track("H5_北亚利桑那大学专题页", {
        咨询按钮名称: name,
      });
      this.clickZiXun()
    },
  },
};
</script>

<style lang="scss" scoped>
.box9 {
  position: relative;
  height: 760px;
  background: url("../../../assets/coursePage/mba/box9/bg.png") no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
 a{
  display: block;
  width: 686px;
height: 96px;
background: #FFFFFF;
border-radius: 48px;
font-family: PingFangSC, PingFang SC;
font-weight: 500;
font-size: 32px;
color: #E65A2E;
line-height: 96px;
text-align: center;
font-style: normal;
margin: 0 auto 0;
 }

  
}
</style>
